import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { EcommerceCategoriaService } from '../services/EcommerceCategoriaService';
import { EcommerceEmpresaService } from '../services/EcommerceEmpresaService';

const EcommerceFooter = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [empresa, setEmpresa] = useState(null);
    const idEmpresa = 1;

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const [empresaResponse, categoriesResponse] = await Promise.all([
                    EcommerceEmpresaService.obtenerEmpresaPorId(idEmpresa),
                    EcommerceCategoriaService.obtenerCategorias(idEmpresa)
                ]);
                setEmpresa(empresaResponse);
                setCategories(categoriesResponse || []);
            } catch (error) {
                console.error('Error cargando footer:', error);
                setCategories([]);
            }
        };

        loadCategories();
    }, []);

    return (
        <footer className="ec-footer">
            <div className="ec-container">
                <div className="ec-footer-grid">
                    {/* Column 1: About */}
                    <div>
                        <div className="ec-footer-logo">
                            <div className="ec-footer-logo-icon">
                                <i className="pi pi-bolt"></i>
                            </div>
                            <span className="ec-footer-logo-text">{empresa?.nombreComercial || empresa?.nombre || 'Mi Tienda'}</span>
                        </div>
                        <p className="ec-footer-desc">
                            Tu tienda de tecnología favorita. Los mejores equipos electrónicos
                            con los mejores precios y envío a todo el país.
                        </p>
                        <div className="ec-footer-contact-item">
                            <i className="pi pi-phone"></i>
                            <span>{empresa?.telefono || '+51 999 888 777'}</span>
                        </div>
                        <div className="ec-footer-contact-item">
                            <i className="pi pi-envelope"></i>
                            <span>{empresa?.email || 'contacto@mitienda.com'}</span>
                        </div>
                        <div className="ec-footer-contact-item">
                            <i className="pi pi-map-marker"></i>
                            <span>Lima, Perú</span>
                        </div>

                        <div className="ec-footer-social">
                            <Button icon="pi pi-facebook" className="ec-footer-social-btn p-button-rounded" />
                            <Button icon="pi pi-instagram" className="ec-footer-social-btn p-button-rounded" />
                            <Button icon="pi pi-twitter" className="ec-footer-social-btn p-button-rounded" />
                            <Button icon="pi pi-youtube" className="ec-footer-social-btn p-button-rounded" />
                        </div>
                    </div>

                    {/* Column 2: Categories */}
                    <div>
                        <h4 className="ec-footer-title">Categorías</h4>
                        <ul className="ec-footer-links">
                            {categories.slice(0, 6).map(cat => {
                                const catLabel = cat.nombre || cat.name || cat.descripcion || `Categoría ${cat.id}`;
                                return (
                                    <li key={cat.id}>
                                        <a
                                            href={`#cat-${cat.id}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate(`/tienda/catalogo?cat=${cat.id}`);
                                            }}
                                        >
                                            {catLabel}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    {/* Column 3: Customer Service */}
                    <div>
                        <h4 className="ec-footer-title">Servicio al Cliente</h4>
                        <ul className="ec-footer-links">
                            <li><a href="#about">Sobre nosotros</a></li>
                            <li><a href="#terms">Términos y condiciones</a></li>
                            <li><a href="#faq">Preguntas frecuentes</a></li>
                            <li><a href="#privacy">Política de privacidad</a></li>
                            <li><a href="#returns">Devoluciones</a></li>
                            <li><a href="#warranty">Garantía</a></li>
                        </ul>
                    </div>

                    {/* Column 4: Payment Methods */}
                    <div>
                        <h4 className="ec-footer-title">Métodos de pago</h4>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            {['pi pi-credit-card', 'pi pi-wallet', 'pi pi-money-bill', 'pi pi-paypal'].map((icon, i) => (
                                <div key={i} style={{
                                    width: 44,
                                    height: 30,
                                    background: 'rgba(255,255,255,0.1)',
                                    borderRadius: 6,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid rgba(255,255,255,0.15)'
                                }}>
                                    <i className={icon} style={{ fontSize: '0.9rem', opacity: 0.7 }}></i>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="ec-footer-bottom">
                    © {new Date().getFullYear()} {empresa?.nombreComercial || empresa?.nombre || 'Mi Tienda'}. Todos los derechos reservados.
                </div>
            </div>
        </footer>
    );
};

export default EcommerceFooter;
